import * as React from 'react';
import { GameProvider } from './GameContext';
import Game, { Props } from './Game';

const OverOrUnder: React.FC<Props> = ({ data, id }) => {
  return (
    <GameProvider>
      <Game id={id} data={data} />
    </GameProvider>
  );
};

export default OverOrUnder;
